import axios from 'axios';
import React, { useState } from "react";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";

const NewContent = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState({
    description: "",
    title: "",
    duration: "",
    chapter_count: "",
    tags: "",
    rfid: "",
    is_kids_favourite: 0,
    is_all_time_classic: 0,
    // is_sleep: 0,
    content_type: "1",
  });

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    if (type === "checkbox") {
      setContent({ ...content, [name]: checked ? "1" : "0" });
    } else {
      setContent({ ...content, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
   e.preventDefault();
   
   // Create a new object excluding unchecked checkboxes
   const filteredContent = {};
   for (const key in content) {
       if (content[key] !== "0") { // Only include if value is not "0"
           filteredContent[key] = content[key];
       }
   }

   const formData = new FormData();
   for (const key in filteredContent) {
     formData.append(key, filteredContent[key]);
   }

   try {
     const response = await apiService.postData("admin/content", formData);
     console.log("Upload successful:", response);
     navigate("/content");
   } catch (error) {
     console.error("Error uploading content:", error);
   }
};


  return (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header">
            <h4>New Content</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Title</label>
                <input type="text" name="title" className="form-control" value={content.title} onChange={handleChange} placeholder="Enter Title" />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea name="description" className="form-control" value={content.description} onChange={handleChange} placeholder="Enter Description"></textarea>
              </div>
              <div className="form-group">
                <label>Duration</label>
                <input type="text" name="duration" className="form-control" value={content.duration} onChange={handleChange} placeholder="Enter Duration" />
              </div>
              <div className="form-group">
                <label>Chapter Count</label>
                <input type="number" name="chapter_count" className="form-control" value={content.chapter_count} onChange={handleChange} placeholder="Enter Content Count" />
              </div>
              <div className="form-group">
                <label>Tags</label>
                <input type="text" name="tags" className="form-control" value={content.tags} onChange={handleChange} placeholder="Enter Tags" />
              </div>
              <div className="form-group">
                <label>RFID</label>
                <input type="text" name="rfid" className="form-control" value={content.rfid} onChange={handleChange} placeholder="Enter RFID" />
              </div>
              <div className="form-group mt-3">
                <label>Content Type</label>
                <div>
                  <label className="me-3">
                    <input
                      type="radio"
                      name="content_type"
                      value="1"
                      checked={content.content_type === "1"}
                      onChange={handleChange}
                    /> Story
                  </label>
                  <label className="me-3">
                    <input
                      type="radio"
                      name="content_type"
                      value="2"
                      checked={content.content_type === "2"}
                      onChange={handleChange}
                    /> Learning
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="content_type"
                      value="3"
                      checked={content.content_type === "3"}
                      onChange={handleChange}
                    /> Song
                  </label>
                </div>
              </div>
              <div className="form-group">
                <label><input type="checkbox" name="is_kids_favourite" checked={content.is_kids_favourite === "1"} onChange={handleChange} /> Is Kids Favourite</label>
              </div>
              <div className="form-group">
                <label><input type="checkbox" name="is_all_time_classic" checked={content.is_all_time_classic === "1"} onChange={handleChange} /> Is All Time Classic</label>
              </div>
              {/* <div className="form-group">
                <label><input type="checkbox" name="is_sleep" checked={content.is_sleep === "1"} onChange={handleChange} /> Is Sleep</label>
              </div> */}
              <div className="d-flex gap-2 mt-3">
                <button type="submit" className="btn btn-primary">
                  <Plus size={16} /> Add Content
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => navigate("/content")}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewContent;
